/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { ContactNode } from '@api';
import { Epic, ofType, StateObservable } from 'redux-observable';
import 'rxjs';
import { catchError, forkJoin, mergeMap, Observable } from 'rxjs';
import CheckoutServiceV2 from 'src/js/enrol/services/CheckoutApiService';
import { IAction } from '../../actions/IshAction';
import { ProcessError } from '../../common/epics/EpicUtils';
import { IshState } from '../../services/IshState';
import { getCheckoutModelFromBackend } from '../actions/Actions';
import * as Actions from '../containers/summary/actions/Actions';
import { ContactNodeService } from '../services/ContactNodeService';

export const GetAllContactNodes: Epic<any, any> = (action$: Observable<IAction>, store: StateObservable<IshState>): Observable<any> => action$
  .pipe(
    ofType(Actions.GET_ALL_CONTACT_NODES_FROM_BACKEND),
    mergeMap(() => {
      const state: IshState = store.value;
      const { contacts } = state.checkout;

      return forkJoin(
        contacts.result.map((id) => CheckoutServiceV2.getContactNode(contacts.entities.contact[id], state.checkout.summary, state.cart, state.checkout.payerId)),
      ).pipe(
        mergeMap((results: ContactNode[]) => {
          const relationsUpdateActions = ContactNodeService.getRelationsUpdateActions(results);
          return [
            ...results.map((node) => Actions.addContactNodeToState(node)),
            getCheckoutModelFromBackend(),
            ...relationsUpdateActions
          ];
        }),
        catchError((e) => ProcessError(e))
      );
    }) 
  );
